import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IconAppGallery, IconApple, IconGooglePlay, IconInstagram, IconSmartTv, IconSplay } from "@/components/icons";
import IconTelegram from "@/components/icons/IconTelegram";

import { IconProps } from "@/@types/general";
import { ROUTES } from "@/config/routes";
import SOCIAL_LINKS from "@/data/social-links.json";
import TV_APPS_LINKS from "@/data/tv-apps-links.json";
import { cn } from "@/utils/cn";

const MobileFooter = () => {
  const { t } = useTranslation();
  const DATA = [
    { title: t("footer.phone-number"), label: "+998 (78) 200 59 95", link: "/movies" },
    { title: t("footer.address"), label: t("Contacts.address"), link: "/series" },
    { title: t("footer.telegram-bot"), label: "splaysupport_bot", link: "/series" },
    { title: t("footer.email"), label: "support@sevimpliplay.tv", link: "/series" },
  ];

  const icons: Record<number, (props: IconProps) => JSX.Element> = {
    0: IconGooglePlay,
    1: IconApple,
    2: IconAppGallery,
    3: IconSmartTv,
  };

  return (
    <footer className="px-4 py-6 md:hidden">
      <IconSplay className="h-[60px] fill-orange-1" />
      <p className="mt-8 text-[14px]">{t("footer.description")}</p>
      <div className="mt-8  grid grid-cols-2 gap-x-4 gap-y-6">
        {DATA.map((item, index) => (
          <div key={index} className={cn("w-full text-[14px]", { "w-[130px]": index === 0 || index === 2 })}>
            <p className="text-on-surface ">{item.title}:</p>
            <p className="w-full">{item.label}</p>
          </div>
        ))}
      </div>
      <div className="mt-8">
        <p className="text-on-surface">{t("footer.in-social")}:</p>
        <div className="mt-3">
          <ul className={"flex items-center gap-[0.938rem] max-lg:gap-2 max-md:gap-[0.938rem]"}>
            <li>
              <Link
                to={SOCIAL_LINKS.INSTAGRAM.LINK}
                title={"Instagram"}
                target={"_blank"}
                rel={"nofollow"}
                className={
                  "block rounded-full bg-surface-container p-[0.625rem] transition-colors hover:bg-surface-container-high"
                }
              >
                <IconInstagram className={"size-6 fill-on-primary"} />
              </Link>
            </li>
            <li>
              <Link
                to={SOCIAL_LINKS.TELEGRAM.LINK}
                title={"Telegram"}
                target={"_blank"}
                rel={"nofollow"}
                className={
                  "block rounded-full bg-surface-container p-[0.625rem] transition-colors hover:bg-surface-container-high"
                }
              >
                <IconTelegram className={"h-6 fill-on-primary"} />
              </Link>
            </li>
            {/* <li>
              <Link
                to={SOCIAL_LINKS.FACEBOOK.LINK}
                title={"Facebook"}
                target={"_blank"}
                rel={"nofollow"}
                className={
                  "hover:bg-surface-container-high bg-surface-container block rounded-full p-[0.625rem] transition-colors"
                }
              >
                <IconFacebook className={"fill-on-primary size-6"} />
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
      <div className="mt-6">
        <p className="mb-3 text-on-surface">{t("footer.available-in")}:</p>
        <div className="flex flex-wrap gap-4">
          {TV_APPS_LINKS.map((link) => {
            const IconComponent = icons[link.id];
            return (
              <Link
                key={link.id}
                to={link.url}
                title={link.name}
                target={"_blank"}
                rel={"nofollow"}
                className={cn(
                  "block rounded-[0.313rem] bg-outline px-3 py-[0.625rem] outline outline-1 -outline-offset-1 outline-outline-variant transition-colors hover:bg-[#FFFFFF26] focus:bg-[#FFFFFF26] focus:outline-on-primary",
                  "max-md:flex  max-md:items-center max-md:justify-center",
                )}
              >
                <IconComponent className={"h-[20px] w-auto"} />
              </Link>
            );
          })}
        </div>
      </div>
      <div className="mt-8">
        <div className={"flex flex-col gap-3"}>
          <Link to={ROUTES.PRIVACY} className={"text-on-surface transition-colors hover:text-on-primary"}>
            {t("privacy-policy")}
          </Link>
          <span className={"text-sm leading-6 text-[#5B5C62] max-md:hidden"}>|</span>
          <Link to={ROUTES.LICENSE} className={"text-on-surface transition-colors hover:text-on-primary"}>
            {t("user-agreement")}
          </Link>
        </div>
        <p className={"mt-3 text-sm/6 text-on-surface"}>
          © SPLAY 2020-{new Date().getFullYear()}. {t("General.all-rights-reserved")}{" "}
        </p>
      </div>
    </footer>
  );
};

export default MobileFooter;
